import { SupportedLocation } from "./types";

export const MEXICO_LOCATIONS: SupportedLocation[] = [
  {
    id: "mx-cdmx-mexico-city",
    cityName: "Mexico City",
    stateName: "CDMX",
    stateAbbreviation: "CDMX",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "cdmx",
    citySlug: "mexico-city-cdmx-mx",
    lat: 19.4326,
    lng: -99.1332,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1750,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["toluca-mex-mx", "puebla-pue-mx", "queretaro-qro-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana del Valle de México (Polanco, Reforma, Santa Fe, Condesa)",
      localContextText: "As the largest economic, financial, and technology hub in Latin America, Mexico City hosts thousands of multinational headquarters, tech startups, corporate law firms, and private medical networks.",
      majorDistricts: [
        { name: "Paseo de la Reforma & Polanco Business District", desc: "Corporate law firms, investment banking advisories, international consultancies, and private clinics." },
        { name: "Santa Fe Financial & Tech Belt", desc: "Software engineering centers, fintech ventures, enterprise architecture, and corporate headquarters." },
        { name: "Roma-Condesa Innovation Hub", desc: "Digital marketing agencies, custom web design studios, architectural consultancies, and creative boutiques." }
      ],
      topSectors: [
        { title: "Financial & Corporate Legal Services", desc: "International law firms, corporate tax advisories, wealth management, and M&A consulting." },
        { title: "Software Technology & Digital Agencies", desc: "Custom software engineering, cloud architecture, UX design, and AI consultancies." },
        { title: "Private Specialty Medicine & Surgery", desc: "Outpatient surgical centers, cosmetic medicine practices, and specialized dental clinics." }
      ],
      majorInstitutions: ["UNAM (Universidad Nacional Autónoma de México)", "Tecnológico de Monterrey (CCM/CSF)", "IPN", "ITAM", "Universidad Iberoamericana"]
    }
  },
  {
    id: "mx-jal-guadalajara",
    cityName: "Guadalajara",
    stateName: "Jalisco",
    stateAbbreviation: "JAL",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "jalisco",
    citySlug: "guadalajara-jal-mx",
    lat: 20.6597,
    lng: -103.3496,
    supportedRadius: 25,
    dataCoverageScore: 96,
    businessCount: 1320,
    relevantCategoryCount: 32,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["aguascalientes-ags-mx", "leon-gue-mx", "queretaro-qro-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de Guadalajara (Zapopan Tech Valley, Puerta de Hierro, Providencia)",
      localContextText: "Known as the Silicon Valley of Mexico, Guadalajara leads Latin America in semiconductor design, software engineering, electronic manufacturing, and tech outsourcing.",
      majorDistricts: [
        { name: "Zapopan Tech Corridor & Software Park", desc: "Semiconductor engineering labs, software consulting firms, enterprise cloud developers, and AI startups." },
        { name: "Puerta de Hierro Financial District", desc: "Private medical groups, legal practices, luxury real estate advisories, and financial consultancies." }
      ],
      topSectors: [
        { title: "Software Engineering & Semiconductor Design", desc: "Embedded software development, microchip design, cloud solutions, and testing labs." },
        { title: "Medical Innovation & Private Clinics", desc: "Specialty outpatient hospitals, dental practices, and physical therapy networks." }
      ],
      majorInstitutions: ["Universidad de Guadalajara (UdeG)", "Tecnológico de Monterrey (Campus Guadalajara)", "ITESO", "Universidad Panamericana"]
    }
  },
  {
    id: "mx-nl-monterrey",
    cityName: "Monterrey",
    stateName: "Nuevo León",
    stateAbbreviation: "NL",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "nuevo-leon",
    citySlug: "monterrey-nl-mx",
    lat: 25.6866,
    lng: -100.3161,
    supportedRadius: 25,
    dataCoverageScore: 96,
    businessCount: 1410,
    relevantCategoryCount: 33,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["saltillo-coa-mx", "chihuahua-chih-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de Monterrey (San Pedro Garza García, Santa Catarina, Apodaca)",
      localContextText: "Mexico's industrial and corporate capital features massive nearshoring investments, steel engineering, automotive suppliers, and Latin America's wealthiest commercial district (San Pedro).",
      majorDistricts: [
        { name: "San Pedro Garza García Corporate Core", desc: "Private equity firms, corporate law practices, industrial conglomerates, and wealth management." },
        { name: "Apodaca & Santa Catarina Industrial Belt", desc: "Automotive component manufacturing, precision metal fabrication, logistics, and automation." }
      ],
      topSectors: [
        { title: "Advanced Industrial Manufacturing & Nearshoring", desc: "Precision stamping, electrical contractors, industrial automation, and HVAC systems." },
        { title: "Corporate Finance & Commercial Law", desc: "Cross-border trade consultancies, corporate taxation, and industrial real estate." }
      ],
      majorInstitutions: ["Tecnológico de Monterrey (ITESM)", "Universidad Autónoma de Nuevo León (UANL)", "Universidad de Monterrey (UDEM)"]
    }
  },
  {
    id: "mx-pue-puebla",
    cityName: "Puebla",
    stateName: "Puebla",
    stateAbbreviation: "PUE",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "puebla",
    citySlug: "puebla-pue-mx",
    lat: 19.0414,
    lng: -98.2063,
    supportedRadius: 20,
    dataCoverageScore: 93,
    businessCount: 850,
    relevantCategoryCount: 28,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["mexico-city-cdmx-mx", "veracruz-ver-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de Puebla (Angelópolis, Finsa Automotive Zone)",
      localContextText: "A major automotive engineering, textile, medical, and higher education hub anchored by massive OEM manufacturing and modern commercial centers.",
      majorDistricts: [
        { name: "Angelópolis Commercial & Medical Core", desc: "Private outpatient hospitals, architectural firms, software consultancies, and financial practices." },
        { name: "FINSA Industrial & Automotive Park", desc: "Tier-1 automotive suppliers, industrial automation integrators, and trade contractors." }
      ],
      topSectors: [
        { title: "Automotive Engineering & Components", desc: "Tool and die, robotics servicing, quality assurance, and mechanical trades." },
        { title: "Higher Education & Specialized Medicine", desc: "Private medical groups, dental care, physical therapy, and software design." }
      ],
      majorInstitutions: ["UDLAP (Universidad de las Américas Puebla)", "BUAP", "Tecnológico de Monterrey (Puebla)"]
    }
  },
  {
    id: "mx-bc-tijuana",
    cityName: "Tijuana",
    stateName: "Baja California",
    stateAbbreviation: "BC",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "baja-california",
    citySlug: "tijuana-bc-mx",
    lat: 32.5149,
    lng: -117.0382,
    supportedRadius: 20,
    dataCoverageScore: 94,
    businessCount: 890,
    relevantCategoryCount: 29,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["hermosillo-son-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Tijuana Cross-Border Metro Area (Zona Río, Otay Mesa Industrial)",
      localContextText: "The largest cross-border medical device, aerospace, and medical tourism hub in North America, located directly adjacent to San Diego, California.",
      majorDistricts: [
        { name: "Zona Río Commercial & Medical District", desc: "Specialized medical tourism centers, dental institutes, legal advisories, and accounting." },
        { name: "Otay Mesa & Pacifico Industrial Parks", desc: "Medical device manufacturing, aerospace assembly, customs brokers, and freight transport." }
      ],
      topSectors: [
        { title: "Medical Device Manufacturing & Health Tourism", desc: "Biocompatible materials testing, dental surgery centers, and outpatient practices." },
        { title: "Cross-Border Logistics & Customs", desc: "International freight forwarding, customs consultancies, and warehouse distribution." }
      ],
      majorInstitutions: ["UABC (Universidad Autónoma de Baja California)", "CETYS Universidad"]
    }
  },
  {
    id: "mx-gue-leon",
    cityName: "León",
    stateName: "Guanajuato",
    stateAbbreviation: "GUE",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "guanajuato",
    citySlug: "leon-gue-mx",
    lat: 21.122,
    lng: -101.6811,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 720,
    relevantCategoryCount: 26,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["guadalajara-jal-mx", "aguascalientes-ags-mx", "queretaro-qro-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de León & Puerto Interior",
      localContextText: "Central Mexico's leather, footwear, automotive logistics, and health sciences hub connected to Guanajuato Puerto Interior.",
      majorDistricts: [
        { name: "Guanajuato Puerto Interior Industrial Park", desc: "Automotive logistics, international freight forwarding, and trade contractors." },
        { name: "Poliforum & Zona Piel Commercial Core", desc: "Footwear technology, design studios, law offices, and marketing shops." }
      ],
      topSectors: [
        { title: "Industrial Trade Services & Logistics", desc: "Electrical contractors, HVAC installation, and commercial transport." },
        { title: "Design & Material Technology", desc: "Synthetic material engineering, product design, and specialized manufacturing." }
      ],
      majorInstitutions: ["Universidad de Guanajuato (Campus León)", "Tecnológico de Monterrey (León)"]
    }
  },
  {
    id: "mx-chih-ciudad-juarez",
    cityName: "Ciudad Juárez",
    stateName: "Chihuahua",
    stateAbbreviation: "CHIH",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "chihuahua",
    citySlug: "ciudad-juarez-chih-mx",
    lat: 31.6904,
    lng: -106.4245,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 680,
    relevantCategoryCount: 25,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["chihuahua-chih-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Ciudad Juárez Manufacturing & Cross-Border Logistics",
      localContextText: "Major North American automotive electronics, appliance manufacturing, and cross-border logistics gateway directly bordering El Paso, Texas.",
      majorDistricts: [
        { name: "Juárez Industrial Parks (Bermúdez / Juarez)", desc: "Automotive harness manufacturing, electronics assembly, and customs operations." },
        { name: "Zona PRONAF Commercial Center", desc: "Legal consultancies, customs advisories, health clinics, and accounting." }
      ],
      topSectors: [
        { title: "Electronics Manufacturing & Assembly", desc: "Circuit board assembly, industrial quality control, and automation." },
        { title: "Cross-Border Freight & Customs", desc: "International logistics, customs brokerages, and industrial maintenance." }
      ],
      majorInstitutions: ["UACJ (Universidad Autónoma de Ciudad Juárez)", "Instituto Tecnológico de Ciudad Juárez"]
    }
  },
  {
    id: "mx-qro-queretaro",
    cityName: "Querétaro",
    stateName: "Querétaro",
    stateAbbreviation: "QRO",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "queretaro",
    citySlug: "queretaro-qro-mx",
    lat: 20.5888,
    lng: -100.3899,
    supportedRadius: 20,
    dataCoverageScore: 95,
    businessCount: 810,
    relevantCategoryCount: 28,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["mexico-city-cdmx-mx", "leon-gue-mx", "san-luis-potosi-slp-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de Querétaro (Aerotech Park, Juriquilla Tech Core)",
      localContextText: "Mexico's premier aerospace engineering, cloud data center (AWS, Microsoft), and advanced automotive R&D capital.",
      majorDistricts: [
        { name: "Aerotech Industrial Park & Aerospace Cluster", desc: "Turbine component manufacturing, avionics engineering, and composite materials testing." },
        { name: "Juriquilla Tech & Education Core", desc: "Cloud data center engineering, software design consultancies, and biotech labs." }
      ],
      topSectors: [
        { title: "Aerospace Engineering & Avionics", desc: "Precision aerospace tooling, non-destructive testing, and aeronautical software." },
        { title: "Cloud Data Centers & Enterprise Software", desc: "Data center infrastructure engineering, cybersecurity, and DevOps consultancies." }
      ],
      majorInstitutions: ["UNAQ (Universidad Aeronáutica en Querétaro)", "UAQ", "Tecnológico de Monterrey (Querétaro)"]
    }
  },
  {
    id: "mx-yuc-merida",
    cityName: "Mérida",
    stateName: "Yucatán",
    stateAbbreviation: "YUC",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "yucatan",
    citySlug: "merida-yuc-mx",
    lat: 20.9674,
    lng: -89.5926,
    supportedRadius: 20,
    dataCoverageScore: 93,
    businessCount: 620,
    relevantCategoryCount: 24,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["cancun-qroo-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de Mérida (Via Montejo, Parque Científico)",
      localContextText: "Southeastern Mexico's commercial, medical, software engineering, and high-quality-of-life investment hub.",
      majorDistricts: [
        { name: "Via Montejo & Prolongación Paseo de Montejo", desc: "Software engineering consultancies, financial advisories, legal offices, and health centers." },
        { name: "Parque Científico Tecnológico de Yucatán", desc: "Renewable energy research, agritech laboratories, and software incubators." }
      ],
      topSectors: [
        { title: "Software Engineering & Remote Tech", desc: "Full-stack software development, web engineering, and digital marketing." },
        { title: "Medical Services & Health Innovation", desc: "Specialty outpatient clinics, dental centers, and diagnostic laboratories." }
      ],
      majorInstitutions: ["UADY (Universidad Autónoma de Yucatán)", "Universidad Anáhuac Mayab"]
    }
  },
  {
    id: "mx-qroo-cancun",
    cityName: "Cancún",
    stateName: "Quintana Roo",
    stateAbbreviation: "QROO",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "quintana-roo",
    citySlug: "cancun-qroo-mx",
    lat: 21.1619,
    lng: -86.8515,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 580,
    relevantCategoryCount: 23,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["merida-yuc-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Cancún Commercial Core & Airport Logistics Corridor",
      localContextText: "The commercial gateway of the Riviera Maya specializing in luxury hospitality technology, marine logistics, international legal advisories, and commercial trades.",
      majorDistricts: [
        { name: "Downtown Cancún Commercial Core", desc: "Legal advisories, real estate brokerages, accounting firms, and digital marketing." },
        { name: "Airport & Cumbres Trade Corridor", desc: "Commercial refrigeration contractors, electrical servicing, and logistics distribution." }
      ],
      topSectors: [
        { title: "Commercial Trade Construction & Refrigeration", desc: "HVAC systems, commercial electrical, solar power installation, and plumbing." },
        { title: "Real Estate & Legal Services", desc: "Cross-border real estate law, accounting practices, and corporate tax consultancies." }
      ],
      majorInstitutions: ["Universidad del Caribe", "Universidad La Salle Cancún"]
    }
  },
  {
    id: "mx-mex-toluca",
    cityName: "Toluca",
    stateName: "Estado de México",
    stateAbbreviation: "MEX",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "estado-de-mexico",
    citySlug: "toluca-mex-mx",
    lat: 19.2826,
    lng: -99.6557,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 710,
    relevantCategoryCount: 26,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["mexico-city-cdmx-mx", "queretaro-qro-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Toluca Valley Automotive & Pharmaceutical Hub",
      localContextText: "A major manufacturing, automotive engine assembly, pharmaceutical manufacturing, and transport hub connected to Mexico City.",
      majorDistricts: [
        { name: "Toluca Industrial Park (2000)", desc: "Automotive engine plants, pharmaceutical formulation labs, and industrial trades." },
        { name: "Metepec Commercial & Professional Belt", desc: "Law practices, dental groups, architectural studios, and accounting." }
      ],
      topSectors: [
        { title: "Pharmaceutical Formulation & Lab Science", desc: "Quality control labs, packaging technology, and chemical testing." },
        { title: "Automotive Mechanical Engineering", desc: "Precision machining, tool maintenance, and electrical servicing." }
      ],
      majorInstitutions: ["UAEM (Universidad Autónoma del Estado de México)", "Tecnológico de Toluca"]
    }
  },
  {
    id: "mx-slp-san-luis-potosi",
    cityName: "San Luis Potosí",
    stateName: "San Luis Potosí",
    stateAbbreviation: "SLP",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "san-luis-potosi",
    citySlug: "san-luis-potosi-slp-mx",
    lat: 22.1565,
    lng: -100.9855,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 650,
    relevantCategoryCount: 25,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["queretaro-qro-mx", "aguascalientes-ags-mx", "leon-gue-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Zona Metropolitana de San Luis Potosí (Parque WTC, Logistik)",
      localContextText: "A key automotive assembly (BMW, GM) and intermodal logistics hub in central Mexico.",
      majorDistricts: [
        { name: "WTC Industrial Park & Logistik Center", desc: "Automotive manufacturing, railway logistics, trade contracting, and customs." },
        { name: "Lomas & Tangamanga Commercial Core", desc: "Private outpatient clinics, law offices, accounting, and software services." }
      ],
      topSectors: [
        { title: "Automotive Engineering & Electric Mobility", desc: "EV battery assembly, automated welding, and industrial engineering." },
        { title: "Intermodal Freight & Customs", desc: "Rail cargo transport, logistics consultancies, and warehousing." }
      ],
      majorInstitutions: ["UASLP (Universidad Autónoma de San Luis Potosí)", "Universidad Politécnica de SLP"]
    }
  },
  {
    id: "mx-ags-aguascalientes",
    cityName: "Aguascalientes",
    stateName: "Aguascalientes",
    stateAbbreviation: "AGS",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "aguascalientes",
    citySlug: "aguascalientes-ags-mx",
    lat: 21.8853,
    lng: -102.2916,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 580,
    relevantCategoryCount: 24,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["guadalajara-jal-mx", "leon-gue-mx", "san-luis-potosi-slp-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Aguascalientes Automotive & Tech Corridor",
      localContextText: "A primary automotive manufacturing hub (Nissan) with emerging software development and IT services.",
      majorDistricts: [
        { name: "Nissan & San Francisco Industrial Parks", desc: "Automotive assembly, robotics maintenance, and trade contracting." },
        { name: "North Commercial Core (Trojes)", desc: "Software agencies, legal practices, accounting offices, and medical centers." }
      ],
      topSectors: [
        { title: "Automotive Robotics & Manufacturing", desc: "Tooling engineering, industrial maintenance, and electrical trades." },
        { title: "IT Services & Software Engineering", desc: "Full-stack development, helpdesk consultancies, and web design." }
      ],
      majorInstitutions: ["UAA (Universidad Autónoma de Aguascalientes)", "Universidad Politécnica de Aguascalientes"]
    }
  },
  {
    id: "mx-chih-chihuahua",
    cityName: "Chihuahua",
    stateName: "Chihuahua",
    stateAbbreviation: "CHIH",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "chihuahua",
    citySlug: "chihuahua-chih-mx",
    lat: 28.6353,
    lng: -106.0889,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 590,
    relevantCategoryCount: 24,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["ciudad-juarez-chih-mx", "monterrey-nl-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Chihuahua Aerospace & Electronics Hub",
      localContextText: "Chihuahua state capital excels in aerospace machining, automotive wiring, and electronic component manufacturing.",
      majorDistricts: [
        { name: "Chihuahua Aerospace Park", desc: "Aerospace machining, wiring harness manufacturing, and testing labs." },
        { name: "Distrito 1 Modern Commerce Belt", desc: "Corporate law, accounting practices, dental institutes, and digital agencies." }
      ],
      topSectors: [
        { title: "Aerospace Machining & Wire Systems", desc: "Precision CNC machining, avionics wiring, and non-destructive testing." },
        { title: "Professional Legal & Financial Services", desc: "Corporate law, international tax consultancies, and wealth management." }
      ],
      majorInstitutions: ["UACH (Universidad Autónoma de Chihuahua)", "Instituto Tecnológico de Chihuahua"]
    }
  },
  {
    id: "mx-son-hermosillo",
    cityName: "Hermosillo",
    stateName: "Sonora",
    stateAbbreviation: "SON",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "sonora",
    citySlug: "hermosillo-son-mx",
    lat: 29.0729,
    lng: -110.9559,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 510,
    relevantCategoryCount: 22,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["tijuana-bc-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Hermosillo Automotive & Solar Energy Hub",
      localContextText: "Capital of Sonora, featuring the Ford Stamping & Assembly plant, solar energy development, and agricultural export technology.",
      majorDistricts: [
        { name: "Ford Industrial Park & Automotive Belt", desc: "Automotive assembly, metal stamping, and electrical contracting." },
        { name: "Pitic & Hotelero Commercial District", desc: "Law offices, accounting consultancies, health clinics, and engineering." }
      ],
      topSectors: [
        { title: "Solar Energy & Automotive Engineering", desc: "Solar panel installation, electrical maintenance, and automotive trades." },
        { title: "Agribusiness & Export Technology", desc: "Crop quality testing, cold storage transport, and international trade." }
      ],
      majorInstitutions: ["Universidad de Sonora (UNISON)", "Instituto Tecnológico de Hermosillo"]
    }
  },
  {
    id: "mx-ver-veracruz",
    cityName: "Veracruz",
    stateName: "Veracruz",
    stateAbbreviation: "VER",
    countryName: "Mexico",
    countryCode: "MX",
    countrySlug: "mexico",
    regionSlug: "veracruz",
    citySlug: "veracruz-ver-mx",
    lat: 19.1738,
    lng: -96.1342,
    supportedRadius: 20,
    dataCoverageScore: 89,
    businessCount: 460,
    relevantCategoryCount: 21,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["puebla-pue-mx", "mexico-city-cdmx-mx"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Veracruz-Boca del Río Maritime & Commerce Core",
      localContextText: "Mexico's most important Gulf seaport, specializing in maritime logistics, international trade, petroleum services, and marine engineering.",
      majorDistricts: [
        { name: "Port of Veracruz & Logistics Zone", desc: "Maritime freight forwarding, customs brokerages, shipping maintenance, and trade." },
        { name: "Boca del Río Modern Commercial Belt", desc: "Law offices, financial advisories, dental clinics, and design studios." }
      ],
      topSectors: [
        { title: "Maritime Freight & Port Logistics", desc: "Customs brokerage, container terminal logistics, and marine engineering." },
        { title: "Commercial Legal & Tax Services", desc: "Customs law consultancies, international trade tax, and accounting." }
      ],
      majorInstitutions: ["Universidad Veracruzana (UV)", "Instituto Tecnológico de Veracruz"]
    }
  }
];
